import { combineReducers } from 'redux';

import apiError from './apiError';
import isLoading from './isLoading';
import isReady from './isReady';
import isUpdating from './isUpdating';
import languages from './languages';
import selectedId from './selectedId';
import selectedLanguage from './selectedLanguage';

export default combineReducers({
  apiError,
  isLoading,
  isReady,
  isUpdating,
  languages,
  selectedId,
  selectedLanguage,
});
